export const courses = [
    {
        id: 1, 
        name: "Bachelor of Business Studies with Education",
        day: "BSD",
        eve: "BSE"
    },
    {
        id: 2, 
        name: "Bachelor of Business Administration",
        day: "BBK",
        eve: "BKE"
    },
    {
        id: 3, 
        name: "Bachelor of Science in Accounting and Finance",
        day: "AFD",
        eve: "AFE"
    },
    
    {
        id: 4, 
        name: "Bachelor of Science in Accounting and Finance",
        day: "AFW",
        eve: "AFW"
    }, 
    {
        id: 5, 
        name: "Bachelor of Administrative Science ",
        day: "AFW",
        eve: "AFW"
    },
    {
        id: 6, 
        name: "Bachelor of Procurement and Logistics Management",
        day: "PLD",
        eve: "PLE"
    },
    {
        id: 7, 
        name: "Bachelor of Management Science",
        day: "MSD",
        eve: "MSE"
    },
    {
        id: 8, 
        name: "Bachelor of Microfinance",
        day: "MFD",
        eve: "MFE"
    },
    {
        id: 9, 
        name: "Bachelor of Vocational Studies in Home Economics with Education ",
        day: "VHD",
        eve: "VHD"
    },
    {
        id: 10, 
        name: "Bachelor of Science in Human Nutrition and Dietetics",
        day: "HND",
        eve: "HND"
    },
    {
        id: 11, 
        name: "Bachelor of Hotel and Institutional Catering",
        day: "HID",
        eve: "HIE"
    },
    {
        id: 12, 
        name: "Diploma in Hotel and Institutional Catering ",
        day: "DHC",
        eve: "DHC"
    },
    {
        id: 13, 
        name: "Diploma in Fashion and Apparel Design",
        day: "FAD",
        eve: "FAD"
    },
    {
        id: 14, 
        name: "Bachelor of Adult and Community Education ",
        day: "ACD",
        eve: "ACE"
    },
    {
        id: 15, 
        name: "Bachelor of Community Development and Social Justice ",
        day: "CSD",
        eve: "CSE"
    },
    
    {
        id: 16, 
        name: "Bachelor of Community Based Rehabilitation",
        day: "CBD",
        eve: "CBE"
    },    
    {
        id: 17, 
        name: "Diploma in Community Based Rehabilitation ",
        day: "CBR",
        eve: "CBR"
    },
    {
        id: 18, 
        name: "Diploma in Sign Language Interpreting",
        day: "SLI",
        eve: "SLI"
    },
    {
        id: 19, 
        name: "Diploma in Mobility and Rehabilitation ",
        day: "MBR",
        eve: "MBR"
    },
    {
        id: 20, 
        name: "Bachelor of Science in Leather Tanning Technology",
        day: "LTD",
        eve: "LTE"
    },
    {
        id: 21, 
        name: "Bachelor of Science Technology - Physics",
        day: "PTD",
        eve: "PTE"
    },
    {
        id: 22, 
        name: "Bachelor of Science Technology - Chemistry",
        day: "CTD",
        eve: "CTE"
    },
    {
        id: 23, 
        name: "Bachelor of Science Technology - Biology",
        day: "BTD",
        eve: "BTE"
    },
    {
        id: 24, 
        name: "Bachelor of Food Science and Processing Technology",
        day: "FPD",
        eve: "FPE"
    },
    {
        id: 25, 
        name: "Bachelor of Science inTextile and Clothing",
        day: "TCD",
        eve: "TCD"
    },
    {
        id: 26, 
        name: "Bachelor of Science in Statistics",
        day: "STD",
        eve: "STE"
    },
    {
        id: 27, 
        name: "Bachelor of Material and Ceramic Science Technology ",
        day: "MCD",
        eve: "MCE"
    },
    {
        id: 28, 
        name: "Bachelor of Science in Sport and Leisure Management",
        day: "LMD",
        eve: "LMD"
    },
   
    {
        id: 29, 
        name: " Bachelor of Environmental Science Technology and Management",
        day: "BMD",
        eve: "BME"
    },
    {
        id: 30, 
        name: "Bachelor of Science with Education (Biological Sciences)",
        day: "ESB",
        eve: "ESB"
    },
    {
        id: 31, 
        name: "Bachelor of Science with Education (Economics) ",
        day: "ESE",
        eve: "ESE"
    },
    {
        id: 32, 
        name: "Bachelor of Science with Education (Physical Sciences) ",
        day: "ESP",
        eve: "ESP"
    },
   
    {
        id: 33, 
        name: "Bachelor of Science in Sport and Exercise Instruction",
        day: "SAD",
        eve: "SEE"
    },
    {
        id: 34, 
        name: "Diploma in Science Technology - Physics ",
        day: "STP",
        eve: "STP"
    },
    {
        id: 35, 
        name: "Diploma in Science Technology - Physics ",
        day: "STP",
        eve: "STP"
    },
    {
        id: 36, 
        name: "Diploma in Science Technology - Chemistry ",
        day: "STC",
        eve: "STC"
    },
    {
        id: 37, 
        name: "Diploma in Science Technology - Biology",
        day: "STB",
        eve: "STB"
    },
    {
        id: 38, 
        name: "Diploma in Food Processing Technology",
        day: "DFP",
        eve: "DFP"
    },
    {
        id: 39, 
        name: "Bachelor of Information Technology and Computing",
        day: "ITD",
        eve: "ITE"
    },
    {
        id: 40, 
        name: "Bachelor of Library and Information Science",
        day: "LID",
        eve: "LIE"
    },
    {
        id: 41, 
        name: "Bachelor of Information Systems",
        day: "ISD",
        eve: "ISE"
    },
    {
        id: 42, 
        name: "Bachelor of Science in Oil and Gas Production ",
        day: "GPD",
        eve: "GPE"
    },
    {
        id: 43, 
        name: "Bachelor of Science in Chemical and Process Engineering ",
        day: "CHD",
        eve: "CHE"
    },
    {
        id: 44, 
        name: "Bachelor of Vocational Studies in Technological Studies with Education.",
        day: "VTD",
        eve: "VTD"
    },
    {
        id: 45, 
        name: "Bachelor of Engineering in Building and Civil Engineering ",
        day: "ECD",
        eve: "ECE"
    },
    {
        id: 46, 
        name: "Bachelor of Engineering in Mechanical and Manufacturing Engineering ",
        day: "EMD",
        eve: "EME"
    },
    {
        id: 47, 
        name: "Bachelor of Telecommunication Engineering ",
        day: "ETD",
        eve: "ETE"
    },
    {
        id: 48, 
        name: "Bachelor of Engineering in Environmental Engineering and Management",
        day: "EED",
        eve: "EEE"
    },
    {
        id: 49, 
        name: "Bachelor of Engineering in Automotive and Power Engineering ",
        day: "APD",
        eve: "APE"
    },
    {
        id: 50, 
        name: "Bachelor of Engineering in Industrial Engineering and Management",
        day: "IED",
        eve: "IEE"
    },
    {
        id: 51, 
        name: "Bachelor of Mechatronics and Biomedical Engineering ",
        day: "BIO",
        eve: "BIE"
    },
    {
        id: 52, 
        name: "Bachelor of Electrical Engineering ",
        day: "BEL",
        eve: "BET"
    },
    {
        id: 53, 
        name: "Diploma in Civil and Building Engineering",
        day: "DCK",
        eve: "DCK"
    },
    {
        id: 54, 
        name: "Diploma in Water Engineering",
        day: "DWE",
        eve: "DWE"
    },
    {
        id: 55, 
        name: "Diploma in Refrigeration and Air Conditioning",
        day: "DRA",
        eve: "DRA"
    },
    {
        id: 56, 
        name: "Diploma in Biomedical Engineering",
        day: "DBE",
        eve: "DBE"
    },
    {
        id: 57, 
        name: "Bachelor of Architecture ",
        day: "ARD",
        eve: "ARD"
    },
    {
        id: 58, 
        name: "Bachelor of Surveying and Land Information Systems ",
        day: "SLD",
        eve: "SLE"
    },
    {
        id: 59, 
        name: "Bachelor of Science in Building Economics ",
        day: "EBD",
        eve: "EBE"
    },
    {
        id: 60, 
        name: "Bachelor of Science in Land Economics",
        day: "BLD",
        eve: "BLE"
    },
    {
        id: 61, 
        name: "Bachelor of Guidance and Counselling",
        day: "BGD",
        eve: "BGE"
    },
    {
        id: 62, 
        name: "Bachelor of Arts in Economics ",
        day: "EKD",
        eve: "EKE"
    },
    {
        id: 63, 
        name: "Bachelor of Demography & Reproductive Health ",
        day: "BRD",
        eve: "BRE"
    },
    {
        id: 64, 
        name: "Bachelor of Development Studies",
        day: "BDD",
        eve: "BDE"
    },
    {
        id: 65, 
        name: "Bachelor of Public Administration and Resource Governance ",
        day: "PAD",
        eve: "PAE"
    },
    {
        id: 66, 
        name: "Bachelor of Arts in Social Sciences ",
        day: "SSD",
        eve: "SSE"
    },
    {
        id: 67, 
        name: "Bachelor of Social Work and Social Administration ",
        day: "SWD",
        eve: "SWE"
    },
    {
        id: 68, 
        name: "Bachelor of Art in Security and Diplomatic Studies ",
        day: "SSD",
        eve: "SDE"
    },
    {
        id: 69, 
        name: "Bachelor of Economics and Statistics ",
        day: "BEK",
        eve: "BEE"
    },
    {
        id: 70, 
        name: "Bachelor of Arts in Arts ",
        day: "AAD",
        eve: "AAE"
    },
    {
        id: 71, 
        name: "Bachelor of Arts with Education",
        day: "AED",
        eve: "AEE"
    },
    {
        id: 72, 
        name: "Bachelor of Performing Arts ",
        day: "BPD",
        eve: "BPE"
    },
    {
        id: 73, 
        name: "Bachelor of Cultural Herritage Studies",
        day: "HCD",
        eve: "HCE"
    },
    {
        id: 74, 
        name: "Bachelor of Archeology and Heritage Management",
        day: "AHD",
        eve: "AHE"
    },
    {
        id: 75, 
        name: "Bachelor of Vocational Studies in Agriculture with Education",
        day: "AGD",
        eve: "AGE"
    },
    {
        id: 76, 
        name: "Bachelor of Art and Industrial Design ",
        day: "AID",
        eve: "AID"
    },
    {
        id: 77, 
        name: "Bachelor of Interior and Landscape Design ",
        day: "BIL",
        eve: "BIL"
    },
    {
        id: 78, 
        name: "Bachelor of Textile and Apparel Design ",
        day: "TAD",
        eve: "TAD"
    },
    {
        id: 79, 
        name: "Bachelor of Computer and Graphic Design ",
        day: "CGD",
        eve: "CGD"
    },
    {
        id: 80, 
        name: "Bachelor of Vocational Studies in Art and Design with Education",
        day: "VAD",
        eve: "VAD"
    },
    {
        id: 81, 
        name: "Diploma in Interior Design ",
        day: "DID",
        eve: "DID"
    },
    {
        id: 82, 
        name: "Diploma in Textiles Design and Surface Design",
        day: "TEX",
        eve: "TEX"
    },
    {
        id: 83, 
        name: "Bachelor of Science in Accounting and Finance ",
        day: "AFB",
        eve: "AFB"
    },
    {
        id: 84, 
        name: "Bachelor of Procurement and Logistics Management",
        day: "PLB",
        eve: "PLB"
    },
    {
        id: 85, 
        name: "Bachelor of Administrative Science ",
        day: "ASB",
        eve: "ASB"
    },
    {
        id: 86, 
        name: "Bachelor of Business Administration",
        day: "BBB",
        eve: ""
    },
    {
        id: 87, 
        name: "Bachelor of Arts with Education",
        day: "AEDB",
        eve: ""
    },
    {
        id: 88, 
        name: "Bachelor of Science with Education (Biological Sciences) ",
        day: "ESBB",
        eve: ""
    },
    {
        id: 89, 
        name: "Bachelor of Science with Education (Economics) ",
        day: "ESEB",
        eve: ""
    },
    {
        id: 90, 
        name: "Bachelor of Science with Education (Physical Sciences)",
        day: "ESPB",
        eve: ""
    },
    {
        id: 91, 
        name: "Bachelor of Arts in Social Sciences ",
        day: "SSDB",
        eve: ""
    },
    {
        id: 92, 
        name: "Bachelor of Community Development and Social Justice ",
        day: "CSDB",
        eve: ""
    },
    {
        id: 93, 
        name: "Bachelor of Science in Accounting and Finance ",
        day: "AFS",
        eve: ""
    },
    {
        id: 94, 
        name: "Bachelor of Procurement and Logistics Management",
        day: "PLDS",
        eve: ""
    },
    {
        id: 95, 
        name: "Bachelor of Administrative Science ",
        day: "ASS",
        eve: ""
    },
    {
        id: 96, 
        name: "Bachelor of Business Administration",
        day: "BBS",
        eve: ""
    },


]